import {
    Checkbox, Component, DataSourceModeChangeEvent, Label, Layout, Panel, Tab, Table, Textbox
} from "@mcleod/components";
import { AutogenLayoutCustomerOptions } from "./autogen/AutogenLayoutCustomerOptions";
import { CreditOverrides } from "./CreditOverrides";
import { CurrencySettings } from "@mcleod/core";
import { getExciseTaxControlBoolean } from "./models/ModelExciseTaxControl";

export class CustomerOptions extends AutogenLayoutCustomerOptions {
    styleTab(tab: Tab, hasData: boolean) {
        if (tab.heading != null && tab.headingLabel != null) {
            tab.heading.color = hasData ? "default.light" : "subtle.light";
            tab.heading.fontBold = hasData;
        }
    }

    styleOverrideTab(tab: Tab, hasData: boolean, count?: number) {
        if (tab.heading != null && tab.headingLabel != null) {
            tab.heading.color = hasData ? "default.light" : "subtle.light";
            tab.heading.fontBold = hasData;
            const overrideTab = this.tabCreditOverrides as Tab;
            overrideTab.headingLabel.fillRow = false;

            if (tab["countLabel"] == null) {
                tab["countLabel"] = new Label({
                    fontBold: true, text: "0", fillRow: true,
                    color: "primary", rowBreak: false, marginLeft: 5
                });
                tab.heading.insert(tab["countLabel"], 1);
            }
            tab["countLabel"].text = count?.toString() ?? "0";
        }
    }

    async sourceCustomerAfterExecution() {
        const currencySettings = CurrencySettings.getSingleton();
        await this.layoutCreditCollections.sourceCreditCalculations.search({
            customer_id: this.sourceCustomer.activeRow?.get("id"),
            currency_type: this.sourceCustomer.activeRow?.get("currency_type", currencySettings.getTransactionalCurrency())
         });
        this.tabsetOptions.tabs.forEach(tab => this.styleTab(tab, this.tabHasData(tab)));
        this.styleOverrideTab(this.tabCreditOverrides, this.tabHasData(this.tabCreditOverrides), this.getOverrideRowCount());
    }

    sourceCustomerFuelAfterExecution() {
        this.styleTab(this.tabFuelSurcharge, this.tabHasData(this.tabFuelSurcharge));
    }


    tabsetOptionsOnDataDisplay(event) {

    }

    tabHasData(tab: Tab): boolean {
        return tab.components.some(component => this.hasDataRecursive(component));
    }

    private hasDataRecursive(component: Component): boolean {
        if (this.componentHasData(component)) {
            return true;
        }

        if (component instanceof Layout || component instanceof Panel) {
            return component.components.some(subComponent => this.hasDataRecursive(subComponent));
        }

        return false;
    }

    componentHasData(component: any): boolean {
        let hasData = false;
        if (component instanceof Textbox) {
            if (component.text != null && component.text.trim().length > 0) {
                hasData = true;
            }
        } else if (component instanceof Checkbox) {
            if (component.checked) {
                hasData = true;
            }
        } else if (component instanceof Table) {
            if (component.rowCount > 0) {
                hasData = true;
            }
        }

        return hasData;
    }

    getOverrideRowCount(): number {
        return (this.layoutCreditOverrides as CreditOverrides).tableCreditOverride.rowCount;
    }

    async sourceCustomerAfterModeChange(event: DataSourceModeChangeEvent) {
        this.layoutFuelSurchargeOptions.customerDataSource = this.sourceCustomer;
        if (CurrencySettings.getSingleton().multiCurrencyEnabled() && getExciseTaxControlBoolean("is_active", false)) {
            this.tabTaxes.visible = true;
        }
    }
}
